import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'

const BuildTeam = () => {
  return (
    <>
        <Card className='no-border rounded-0 industrial-modeling-top-section container build-a-team py-5 py-md-0'>
            <Card.Body>
                <Card.Title className='text-center industrial-modeling-title pt-md-5'> チームビルディング </Card.Title>
                <Card.Subtitle className="text-center build-team-subheading  py-4"> 開発者提供サービスプログラム（Developer as a Service program: ダースプログラム） </Card.Subtitle>
                <Card.Text className='text-left build-team-content'>
                最先端の企業は、ARとVRの利点に注目しています。しかし、これらを用いたプログラムを実現するための最大の課題の1つは、AR/VRコンテンツやプラットフォームを構築する経験を持つアーティスト、開発者、エンジニアといった人材確保の難しさです。
                </Card.Text>

                <Card.Title className='text-left build-team-heading'> リモートワーカーの採用 </Card.Title>
                <Card.Text className='text-left build-team-content'>
                    社内のVR人材を探し、審査し、雇用することは、費用や時間がかかり、当たり外れが大きい場合があります。AR/VRのスキルは専門的であり、利用できる人材は高額な報酬を支払わなければ見つけることが困難です。
                 <br />  <br /> 
                    私たちは、世界中の高度な技術を持ち、かつ手頃な料金でリソースを提供することが可能です。私たちは優秀なエンジニア、デザイナー、アーティストなどを採用し、トレーニングすることで、お客さまのプロジェクトに必要なスタッフを確保しております。これにより、プロジェクトの迅速な立ち上げ、市場投入が可能となり、トップクラスの AR/VR 人材と共に仕事をすることが可能です。
                </Card.Text>

                <Card.Title className='text-left build-team-heading'> プロジェクト思考からの脱却 </Card.Title>
                <Card.Text className='build-team-content text-left'>
                私たちは外部のサービスプロバイダーとしてお客さまからプロジェクト単位で依頼されることが多いですが、私たちはお客さまにとってAR/VR開発のライフサイクルを通じたパートナーでありたいと願っています。
                <br />  <br /> 
                パラコズマの「開発者提供サービスプログラム」では、私たちのチームがお客様のチームとなります。私たちはフルタイムとパートタイムのスペシャリストによって構成される専門チームを作り、社内チームと同じようにお客さまをサポートいたします。その結果、お客さま自身が自社で専門スタッフを雇用される代わりに、以下のようなメリットが得られます。
                </Card.Text>
                <Row className='px-md-0 px-sm-2 py-md-4 '>
                    <Col xs={{span:12, offset:0}} md={{span:5, offset:1}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={"/assets/icons/bt_001.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text> ・ニーズの変化に応じてスペシャリストを変更できる柔軟性 </Card.Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={"/assets/icons/bt_002.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text> ・全て込みの価格設定 </Card.Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12, offset:0}} md={{span:5, offset:1}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={"/assets/icons/bt_003.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text> ・募集・採用・入社・資格取得・継続的なスキルの育成サポート </Card.Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={"/assets/icons/bt_004.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text> ・最新のツールや技術の開発現場への導入 </Card.Text>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Card.Text className='container build-team-content text-left team-build-buttom-heading'>  パラコズマのDAASチームは、以下のような企業に導入されています。 </Card.Text>
                
                <Row className='no-padding-x'>
                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={"/assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'> ・FDAの承認を目指してデジタル治療薬を開発する大手VRヘルスケア企業 </Card.Text>
                    </Col>

                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={"/assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'> ・没入型教育を専門とする大手オンライン大学 </Card.Text>
                    </Col>

                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={"/assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'> ・ファイル変換やサードパーティとの統合を支援するVR企業向け生産性向上アプリを開発する企業 </Card.Text>
                    </Col>

                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={"/assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'> ・エグゼクティブのリクルーティングとオンボーディングを行う企業 </Card.Text>
                    </Col>
                </Row>

                <Card.Title className='text-left build-team-heading'> 貴社向けのチームを構築します </Card.Title>
                <Card.Text className='text-left build-team-content'>
                お客さまの目的をお伺いした上で、理想的なチーム構成を決定し、お見積させていただきます。
                </Card.Text>

                

             
            </Card.Body>
            <Button className='build-team-request-button shelterinplacevr-button btn btn-warning text-center'> <a href="https://www.paracosma.com/jp/#contact-form" target="_blank" rel="noreferrer">相談予約</a> </Button>

        </Card>
      
    </>
  )
}

export default BuildTeam
